export const SUPPORTING_DOCUMENTS = 'supporting-documents';

export const LICENCE_DETAILS = 'renew-licence-details';

export const RENEW_LICENCE_APPLICATION = [
    {
        sectionID: LICENCE_DETAILS,
        sectionName: 'Licence Particulars',
        fieldList: [
            {
                id: 'licensee-nric',
                label: 'Licensee NRIC',
                type: 'text'
            },
            {
                id: 'registration-no-uen-other',
                label: 'Registration No Uen Other',
                type: 'text'
            }
        ]
    },
    {
        sectionID: LICENCE_DETAILS,
        sectionName: 'Licence Renewal',
        fieldList: [
            {
                id: 'licence-no',
                label: 'Licensee No',
                type: 'text'
            },
            {
                id: 'dateOfExpiry',
                label: 'Date Of Expiry',
                type: 'text'
            },
            {
                id: 'invoiceNo',
                label: 'Invoice Number',
                type: 'text'
            },
            {
                id: 'paymentDueDate',
                label: 'Payment Due Date',
                type: 'text'
            },
            {
                id: 'renewalAmount',
                label: 'Renewal Amount',
                type: 'text'
            },
            {
                id: 'renewalPeriod',
                label: 'Renewal Period',
                type: 'text'
            },
            {
                id: 'giroIndicator',
                label: 'GIRO Indicator',
                type: 'text'
            }
        ]
    }
];
